import PaginatedController, {
  PAGINATED_CONTROLLER_QUERY_PARAMS,
} from 'core/controllers/paginated-controller';
import { tracked } from '@glimmer/tracking';

export default class CloudOrgsDetailProjectsListController extends PaginatedController {
  queryParams = [...PAGINATED_CONTROLLER_QUERY_PARAMS, 'query'];

  @tracked query;

  resetPagination() {
    this._reset();
    this.query = undefined;
  }
}
